// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"48cf9b6b","511":"8aed6023","787":"868733d2","902":"3bfed016"}[chunkId] + ".chunk.js";
};